import React from "react";
import { BookOutlined, PlusOutlined } from "@ant-design/icons";
import CcButton from "./CcButton";

interface PageHeaderProps {
  onOpenGlossary: () => void;
  onCreateConfiguration: () => void;
}

const PageHeader = ({ onOpenGlossary, onCreateConfiguration }: PageHeaderProps) => (
  <header className="page-header">
    <div className="page-header__identity">
      <h1 className="page-header__title">Coil Configurator</h1>
      <p className="page-header__breadcrumb">Engineering · Field Joint Heating</p>
    </div>
    <div className="page-header__actions">
      <CcButton variant="secondary" className="glossary-button" icon={<BookOutlined />} onClick={onOpenGlossary}>
        Glossary
      </CcButton>
      <CcButton variant="primary" icon={<PlusOutlined />} onClick={onCreateConfiguration}>
        Create Coil Configuration
      </CcButton>
    </div>
  </header>
);

export default PageHeader;
